/* eslint-disable @typescript-eslint/naming-convention */

const DASH_LETTER_SPACE_PATTERN_STARTS_WITH_LETTER = /^[a-z\-\s]+$/i;
const DASH_LETTER_SPACE_QUOTE_PATTERN_STARTS_WITH_LETTER = /^[a-z](_?[a-z\-\s']+)*$/i;
export const Patterns = {
    FIRST_NAMES: DASH_LETTER_SPACE_PATTERN_STARTS_WITH_LETTER,
    GIVEN_NAME: DASH_LETTER_SPACE_PATTERN_STARTS_WITH_LETTER,
    INITIALS: /^[a-z.\s]+$/i,
    INSERTION: /^([a-z\-']{2,}\s?)+$/i,
    INSERTION_VALIDATION: /^(vd|vt|vh|od)$/i,
    LASTNAME: DASH_LETTER_SPACE_QUOTE_PATTERN_STARTS_WITH_LETTER
};
export const FieldLengths = {
    FIRSTNAMES: 56,
    GIVENNAME: 15,
    INITIALS: 10,
    INSERTION: 15,
    LASTNAME: 28
};
